import {
  Box,
  Tabs,
  Tab,
  TextField,
  Stack,
  MenuItem,
  Button,
  styled,
  Badge,
  Autocomplete,
  InputLabel,
  Select,
  Checkbox,
  createFilterOptions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { toast, ToastContainer } from "react-toastify";
import { Redirect } from "react-router-dom";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import Typography from "@mui/material/Typography";
import AdminSidebar from "../../Components/AdminPanel/AdminSidebar";
toast.configure();

const MrCorrection = () => {
  const userToken = LocalstorageHelper.GetAdminToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/" />;
    }
  };
  const [mrRow, setMrRow] = useState([]);
  const [finyearname, setfinyearname] = useState(null);
  const [disableUpdate, setdisableUpdate] = useState(false);
  const [mrinput, setmrinput] = useState(null);
  const [mropts, setmropts] = useState([]);
  const [finopts, setfinopts] = useState([]);
  const [receivedby, setreceivedby] = useState("");
  const receivedByopts = [
    {
      value: "CS",
      label: "Cash",
    },
    {
      value: "CQ",
      label: "Cheque",
    },
    {
      value: "ON",
      label: "Online",
    },
  ];
  const OPTIONS_LIMIT = 15;
  const filterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT,
    trim: true,
  });
  //fetch finyear
  async function getfindetails() {
    try {
      const response = await fetch("/admin/findetails", {
        method: "GET",
        headers: { token: userToken },
      });
      const jsonData = await response.json();
      setfinopts(jsonData);
      // Set the default financial year to 2025-2026
      const defaultFinyear = jsonData.find(
        (year) => year.finname === "2025-2026"
      );
      if (defaultFinyear) {
        setfinyearname(defaultFinyear.finyearid);
      }
      // console.log(jsonData);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getfindetails();
  }, []);

  const handleItemFetch = async () => {
    try {
      const requestdata = await fetch(`/admin/mrcorr/mrs/${finyearname}`, {
        method: "GET",
        headers: { token: userToken },
      });
      const data = await requestdata.json();
      if (data.type === "success") {
        setmropts(data.data);
      } else {
        toast.error("Something Went Wrong Fetching MRNOS!");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    finyearname !== null && handleItemFetch();
  }, [finyearname]);

  const handleUpdateMr = async () => {
    try {
      const body = { mode: receivedby, mrid: mrinput?.mrid };
      const requestupdate = await fetch("/admin/mrflag/up", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: userToken,
        },
        body: JSON.stringify(body),
      });
      const res = await requestupdate.json();
      if (res.type === "success") {
        toast.success(res.message);
        setTimeout(() => {
            window.location.reload()
        }, 2000);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <>
      <ToastContainer />
      <AdminSidebar />
      <Stack direction={"row"} spacing={2} justifyContent={"center"} mt={1}>
        <Typography variant="h6">Money Receipt Correction:</Typography>
      </Stack>
      <Stack direction={"row"} spacing={2} ml={10} mt={6}>
        <TextField
          id="Finyear"
          required
          name="Finyear"
          select
          label="Select Finyear"
          value={finyearname}
          onChange={(e) => setfinyearname(e.target.value)}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "10%",
          }}
          size="small"
        >
          {finopts.map((finyear) => (
            <MenuItem
              key={Object.values(finyear)[0]}
              value={Object.values(finyear)[0]}
            >
              {Object.values(finyear)[1]}
            </MenuItem>
          ))}
        </TextField>
        <Autocomplete
          id="mrid"
          value={mrinput}
          filterOptions={filterOptions}
          onChange={(event, newValue, reason) => {
            if (reason === "clear") {
              setmrinput(null);
              setMrRow([]);
              setreceivedby("");
            } else {
              setmrinput(newValue);
              setMrRow([newValue]);
              setreceivedby(newValue?.recv_by || "");
            }
          }}
          options={mropts}
          getOptionLabel={(option) => option.mr_no}
          sx={{
            width: "30% ",
          }}
          renderInput={(billopts) => (
            <TextField required {...billopts} placeholder="MR No" />
          )}
          size="small"
        />
        <TextField
          id="receivedBy"
          name="receivedby"
          required
          select
          label="Received By"
          value={receivedby}
          onChange={(e) => {
            setreceivedby(e.target.value);
          }}
          variant="outlined"
          sx={{
            width: "20%",
          }}
          size="small"
        >
          {receivedByopts.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      {mrRow.length > 0 && (
        <Stack direction={"row"} spacing={2} ml={10} mt={4}>
          <Box sx={{ minWidth: 650 }}>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
              }}
            >
              <Table
                sx={{
                  minWidth: 650,
                  "& .MuiTableCell-head": {
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontWeight: "bold",
                  },
                  "& .MuiTableCell-body": {
                    fontSize: "0.875rem",
                    padding: "8px",
                  },
                  "& .MuiTableRow-root:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>MR NO</TableCell>
                    <TableCell align="right">MR Date</TableCell>
                    <TableCell align="right">Party Name</TableCell>
                    <TableCell align="right">Mode</TableCell>
                    <TableCell align="right">Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mrRow?.map((row) => (
                    <TableRow
                      key={row.itemid}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.mr_no}
                      </TableCell>
                      <TableCell align="right">{row.date}</TableCell>
                      <TableCell align="right">{row.partyname}</TableCell>
                      <TableCell align="right">{row.recv_by}</TableCell>
                      <TableCell align="right">{row.mr_amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Stack>
      )}
      <Stack direction={"row"} spacing={2} ml={10} mt={6}>
        <Button
          onClick={handleUpdateMr}
          disabled={mrinput?.recv_by === receivedby}
          size="smaill"
          variant="contained"
          color="primary"
        >
          Update
        </Button>
      </Stack>
      {redirectToLoginPage()}
    </>
  );
};

export default MrCorrection;
